import React, { useEffect, useState } from "react";
import Axios from "axios";
import url from "../services/url";
import swal from "sweetalert";
import {
  Formik,
  Form,
  Field,
  ErrorMessage,
  useField,
  useFormikContext,
} from "formik";
import Select from "react-select";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import Interview from "./Interview";
import config from "../config";
import slugify from "slugify";
import ButtonHint from "./ButtonHint";
import ReactLoading from "react-loading";
// import { Card } from "antd";
import { Card, Modal } from "antd";
import TinAssign from "../pages/Dashboard/TinManagement/TinAssign";
import TinManageArrange from "../pages/Dashboard/components/TinManageArrange";
import useAxios from "../hooks/useAxios";

const DatePickerField = ({ ...props }) => {
  const { setFieldValue } = useFormikContext();

  const [field] = useField(props);
  return (
    <DatePicker
      {...field}
      {...props}
      selected={(field.value && new Date(field.value)) || null}
      onChange={(val) => {
        setFieldValue(field.name, val);
      }}
    />
  );
};

const validationSchema = Yup.object({
  type: Yup.string().required("Please choose a Interview Type"),

  interviewer: Yup.string().when("type", {
    is: (type) =>
      type === "final" || type === "L4" || type === "L2" || type === "L1",
    then: (schema) => schema.required("Please choose a user."),
    otherwise: (schema) => schema.notRequired(),
  }),

  clientInterviewer: Yup.string().when("type", {
    is: (type) => type === "clientRound",
    then: (schema) => schema.required("Please choose a user."),
    otherwise: (schema) => schema.notRequired(),
  }),

  description: Yup.string(),
  link: Yup.string(),

  start: Yup.date().required("You must specify a start date."),
  end: Yup.date().required("You must specify an end date."),
});

const generateRandomNumber = () => {
  if (typeof window === "undefined") return Math.floor(Math.random() * 99999);

  const cryptoObj = window.crypto || window.msCrypto;
  const array = new Uint32Array(1);
  cryptoObj.getRandomValues(array);
  return array[0];
};

function getInterviewHeading(type) {
  switch (type) {
    case "face":
      return "Face To Face";
    case "video":
      return "Video conference";
    case "telephone":
      return "Telephonic";
    case "L4":
    case "final":
      return "Final";
    case "versant":
      return "Versant";
    case "clientRound":
      return "Client";
    case "L1":
      return "L1";
    case "L2":
      return "L2";
    case "L3":
      return "L3";
    default:
      return "Interview";
  }
}

function CandidateSingleInterview({
  id,
  candidate,
  processes,
  interviews,
  getInterviews,
  setInterviewStatus,
  interviewStatus,
  users,
  loadCandidate,
  refreshInterviewDetails,
  s3Files,
  getDoc,
  getProcessBasedVersantConf,
  tinData,
  tinOptions,
  canArrangeInterview,
  canTakeInterview,
  canMakeInterviewEditable,
  canEditTrf,
  isCallDiscussionPending,
}) {
  // States
  const api = useAxios();
  const userId = localStorage.getItem("user.id");
  const randomNum = generateRandomNumber();

  // console.log("candidate", candidate);

  const [expanded, setExpanded] = useState(false);
  const [expandedInterviews, setExpandedInterviews] = useState([]);
  const [load, setLoad] = useState(false);
  const [clientData, setClientData] = useState([]);
  const [disable, setDisable] = useState(false);
  const [disables, setDisables] = useState("");
  const [allInterviewStatus, setAllInterviewStatus] = useState([]);
  const [rejectionReasonParameterList, setRejectionReasonParameterList] =
    useState([]);
  const [versantSkipMode, setVersantSkipMode] = useState(false);
  const [versantSkipReason, setVersantSkipReason] = useState("");
  const [sendingInterviewLink, setSendingInterviewLink] = useState(false);

  const { processId } = candidate?.trf || {};
  const isAgent = candidate?.trf?.candidateType !== "Non-Agent";
  const workModal = isAgent
    ? String(candidate?.trf?.workModal || "WFO").toUpperCase()
    : null;

  useEffect(() => {
    getStatusParameters();
  }, []);

  useEffect(() => {
    if (!processId) return;
    getProcessWiseClient();
  }, [processId]);

  const getProcessWiseClient = async () => {
    try {
      const { data } = await api.get(`/clientProcess/processId/${processId}`, {
        tokenType: "user",
      });

      setClientData(data.userList);
    } catch (err) {
      console.error(err);
    }
  };

  const getStatusParameters = async () => {
    try {
      const { data } = await api.get(`/statusParametersMaster`, {
        tokenType: "user",
      });

      const rejectedReasons = data?.find(
        (reason) => reason?.name === "Rejected",
      );
      setAllInterviewStatus(data);
      setRejectionReasonParameterList(rejectedReasons?.parameterList);
    } catch (err) {
      console.error(err);
    }
  };

  const isMandatoryInterviewLink = (interviewType) =>
    isAgent &&
    workModal === "WFH" &&
    ["L2", "versant", "L3", "final", "clientRound"].includes(interviewType);

  const isProfilePhotoUploaded = () => {
    if (candidate?.candidatePhoto && candidate.candidatePhoto.length > 0) return true;
    if (candidate?.photoFilledStatus === true) return true;
    if (s3Files?.photo && s3Files.photo !== "") return true;
    if (s3Files?.candidatePhoto && s3Files.candidatePhoto !== "") return true;
    if (
      candidate?.files &&
      candidate.files.some(
        (f) => f.fieldname && f.fieldname.toLowerCase().includes("profile photo:")
      )
    ) return true;
    return false;
  };

  // Events
  const onSubmitInterview = async (interview, { setSubmitting }) => {
    if (interview.start >= interview.end) {
      swal({
        icon: "error",
        title: "End Date & Time must be greater than start date & Time",
      });
      setSubmitting(false);
      return;
    }

    if (candidate?.trf?.title === undefined) {
      swal({
        icon: "error",
        title: "Please Select Location & TRF",
      });
      setSubmitting(false);
      return;
    }

    if (candidate?.responses?.length === 0 && totalArrangedInterView > 0) {
      swal({
        icon: "error",
        title: "Please complete candidate form",
      });
      setSubmitting(false);
      return;
    }

    if (candidate?.trf?.Status === false) {
      swal({
        icon: "error",
        title: "Please Edit Location & TRF",
      });
      setSubmitting(false);
      return;
    }

    if (interview.type === "versant" && count === 0) {
      swal({
        icon: "error",
        title: "TIN not available.",
      });
      setSubmitting(false);
      return;
    }

    if (
      isMandatoryInterviewLink(interview.type) &&
      !interview.sendInterviewLink
    ) {
      swal({
        icon: "warning",
        title: "Please select 'Send Interview Link' before arranging.",
      });
      setSubmitting(false);
      return;
    }

    if (interview.sendInterviewLink && !isProfilePhotoUploaded()) {
      swal({
        icon: "warning",
        title: "Please upload candidate profile photo before sending interview link.",
      });
      setSubmitting(false);
      return;
    }

    let interviewLinkData = null;
    if (isAgent && interview.sendInterviewLink) {
      try {
        setSendingInterviewLink(true);
        const selectedInterviewer =
          interview?.type === "clientRound"
            ? interview?.clientInterviewer
            : interview?.type === "versant"
              ? userId
              : interview?.interviewer;

        const { data } = await api.post(
          "/interviews/send-link",
          {
            candidateId: id,
            interviewType: interview.type,
            interviewBy: selectedInterviewer || userId,
            start: interview.start,
          },
          { tokenType: "user" },
        );
        interviewLinkData = data;
      } catch (e) {
        swal({
          icon: "error",
          title:
            e?.response?.data?.error || "Unable to send the interview link.",
        });
        setSubmitting(false);
        return;
      } finally {
        setSendingInterviewLink(false);
      }
    }

    await InterviewSubmit(interview, interviewLinkData);
  };

  async function InterviewSubmit(interview, interviewLinkData = null) {
    const { clientInterviewer, sendInterviewLink, ...rest } = interview;
    const interviewLinkSent = Boolean(sendInterviewLink && interviewLinkData);
    const agentLinkData = isAgent
      ? {
        link: interviewLinkSent ? interviewLinkData.link : rest.link,
        sendInterviewLink: interviewLinkSent,
        interviewLinkSentAt: interviewLinkSent
          ? interviewLinkData.interviewLinkSentAt
          : null,
        interviewLinkSentBy: interviewLinkSent
          ? interviewLinkData.interviewLinkSentBy
          : null,
      }
      : {};
    try {
      setLoad(true);
      setDisable(true);
      const { data } = await api.post(
        `/interviews`,
        {
          ...rest,
          ...agentLinkData,
          interviewer:
            interview?.type === "clientRound"
              ? clientInterviewer
              : interview?.type === "versant"
                ? userId
                : interview.interviewer,
          candidate: id,
        },
        { tokenType: "user" },
      );
      if (data.message === "Interview arranged!") {
        await loadCandidate();
        setDisable(false);
        setLoad(false);
        setExpanded(false);
      }
      await getInterviews(id);
    } catch (e) {
      setDisables(
        e?.response?.data?.error?.name ||
        e?.response?.data?.error ||
        "Unable to arrange interview.",
      );
      setLoad(false);
      setDisable(false);
      setTimeout(() => {
        setDisables("");
      }, 3000);
    } finally {
      setLoad(false);
      setDisable(false);
    }
  }

  function toggleExpanded(e) {
    setExpanded(!expanded);
  }

  function toggleExpandedInterview(id) {
    setExpandedInterviews((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  }

  async function handleSkipVersant(reasonParam) {
    const reasonToUse = reasonParam || versantSkipReason;
    if (!reasonToUse) {
      swal({
        icon: "error",
        title: "Please select a reason for skipping Versant.",
      });
      return;
    }
    try {
      setLoad(true);
      setDisable(true);
      await api.post(
        `/interviews/skipVersant`,
        {
          candidateId: id,
          reason: reasonToUse,
          interviewBy: userId,
        },
        { tokenType: "user" },
      );
      setVersantSkipMode(false);
      setVersantSkipReason("");
      await swal({
        icon: "success",
        title: "Versant round skipped successfully.",
      });
      await loadCandidate();
      await getInterviews(id);
      window.location.reload();
    } catch (e) {
      swal({
        icon: "error",
        title: e?.response?.data?.error || "Failed to skip Versant round.",
      });
    } finally {
      setLoad(false);
      setDisable(false);
    }
  }

  async function onClickArrangeWithMe(e) {
    if (candidate?.trf?.title === undefined) {
      swal({
        icon: "error",
        title: "Please Select Location & TRF",
      });
    } else if (candidate.responses.length === 0 && totalArrangedInterView > 0) {
      swal({
        icon: "error",
        title: "Please complete candidate form",
      });
    } else {
      setInterviewStatus(!interviewStatus);
      try {
        const interview = {
          processId: null,
          rejectionReason: "",
          type: "L1",
          interviewer: userId,
          interviewBy: userId,
          description: "A quick interview was arranged.",
          link:
            config.interviewConferenceLink +
            slugify(candidate.name).toLowerCase() +
            "-" +
            randomNum,
          start: new Date(),
          end: new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate(),
            new Date().getHours(),
            new Date().getMinutes() + 30,
          ),
          candidate: id,
        };
        setDisable(true);
        setLoad(true);
        const res = await Axios.post(url("interviews"), interview, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        });
        if (res.data.message === "Interview arranged!") {
          // Success
        }
        await getInterviews(id);
      } catch (e) {
        swal({
          icon: "error",
          title: "Some error occurred",
        });
        console.error(e);
      } finally {
        setDisable(false);
        setLoad(false);
      }
    }
  }

  const totalArrangedInterView = interviews.length;
  const roundFirst = interviews[0] ? interviews[0].status : "";
  const roundSecond = interviews[1] ? interviews[1].status : "";
  const roundThird = interviews[2] ? interviews[2].status : "";
  const tinType = tinData?.versantBasedTRF?.versantType;
  const voice = tinData?.voiceCount || 0;
  const written = tinData?.writtenCount || 0;
  const count =
    tinType === "both"
      ? voice + written
      : tinType === "voice"
        ? voice
        : written;

  const finalInterviewArranged = !interviews.some((_) => _.type === "client");



  const getInterviewType = () => {
    if (totalArrangedInterView === 0) return "L1";
    if (totalArrangedInterView === 1) return "L2";
    if (totalArrangedInterView === 2) {
      if (tinType) {
        return "versant";
      }
      return "";
    }
    if (totalArrangedInterView === 3) {
      const versantInterview = interviews.find(
        (interview) => interview.type === "versant",
      );

      if (versantInterview?.isVersantNotRequired === true) {
        return versantInterview.clientRoundExist === true
          ? "clientRound"
          : "final";
      }

      return "";
    }
    return "clientRound";
  };

  const defaultInterviewType = getInterviewType();

  const initialValues = {
    processId: null,
    rejectionReason: "",
    clientInterviewer: "",
    type: defaultInterviewType,
    interviewer: "",
    interviewBy: userId,
    sendInterviewLink: false,
    description: "",
    link:
      config.interviewConferenceLink +
      slugify(candidate.name).toLowerCase() +
      "-" +
      randomNum,
    start: new Date(),
    end: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
      new Date().getHours(),
      new Date().getMinutes() + 30,
    ),
  };

  return (
    <div>
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <div className="p-0">
        {interviews.length === 0 ? (
          <div className="mt-2">No interview has been assigned.</div>
        ) : (
          <div>
            {interviews
              ?.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
              ?.map((interview, k) => {
                return (
                  <Card bodyStyle={{ padding: "0 24px" }}>
                    <div className="card-header flex justify-content-between gap-2 p-2 card-custom">
                      <div className="flex py-2 justify-content-between gap-3">
                        <div>
                          <i
                            className="fa fa-calendar"
                            aria-hidden="true"
                            style={{ fontSize: 40 }}
                          ></i>
                        </div>
                        <div>
                          <span>
                            <strong>
                              {k + 1}. {getInterviewHeading(interview.type)}{" "}
                              interview
                            </strong>{" "}
                          </span>
                          <br />
                          {/* with {interview.interviewer} */}
                          {interview.start}
                        </div>
                      </div>
                      <div className="InterviewActBtns flex justify-content-end align-items-center">
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() =>
                            toggleExpandedInterview(interview?._id)
                          }
                        >
                          <i
                            className={
                              expandedInterviews.includes(interview._id)
                                ? "fa fa-minus-circle"
                                : "fa fa-plus-circle"
                            }
                          ></i>
                        </button>
                      </div>
                    </div>
                    {expandedInterviews.includes(interview._id) && (
                      <>
                        <Interview
                          processes={processes}
                          interview={interview}
                          allInterviewStatus={allInterviewStatus}
                          rejectionReasonParameterList={
                            rejectionReasonParameterList
                          }
                          getProcessBasedVersantConf={
                            getProcessBasedVersantConf
                          }
                          isCallDiscussionPending={isCallDiscussionPending}
                          canTakeInterview={canTakeInterview}
                          canMakeInterviewEditable={canMakeInterviewEditable}
                          canEditTrf={canEditTrf}
                          expandedInterviews={expandedInterviews}
                          tinData={tinData}
                          interviews={interviews}
                          key={k}
                          index={k + 1}
                          candidate={candidate}
                          loadCandidate={loadCandidate}
                          refreshInterviewDetails={refreshInterviewDetails}
                          setInterviewStatus={setInterviewStatus}
                          s3Files={s3Files}
                          getInterviews={getInterviews}
                          getDoc={getDoc}
                        />
                      </>
                    )}
                  </Card>
                );
              })}
          </div>
        )}
        <>
          {canArrangeInterview && !isCallDiscussionPending && (
            <>
              {totalArrangedInterView <= 3 &&
                (interviews.length === 0 ||
                  (roundFirst === "Selected" &&
                    roundSecond === "Selected" &&
                    interviews[2]?.type === "versant" &&
                    (interviews[2]?.clientRoundExist === true || interviews[2]?.isVersantNotRequired === true) &&
                    roundThird === "Selected") ||
                  (roundFirst === "Selected" &&
                    roundSecond === "Selected" &&
                    roundThird === "") ||
                  (roundFirst === "Selected" &&
                    roundSecond === "" &&
                    roundThird === "")) &&
                finalInterviewArranged && (
                  <div className="card mt-3">
                    <div className="card-header flex">
                      Arrange Interview
                      <div className="ml-auto d-flex align-items-center">
                        {totalArrangedInterView === 2 && tinType && (
                          <div className="mr-2" style={{ position: "relative" }}>
                            <button
                              type="button"
                              className="btn btn-outline-warning btn-sm font-weight-bold"
                              onClick={(e) => {
                                e.stopPropagation();
                                setVersantSkipMode(true);
                              }}
                              disabled={disable}
                            >
                              <i className="fa fa-ban mr-1"></i>
                              Versant Not Required
                            </button>
                            <Modal
                              title="Versant Not Required"
                              visible={versantSkipMode}
                              width={400}
                              onCancel={() => {
                                setVersantSkipMode(false);
                                setVersantSkipReason("");
                              }}
                              footer={[
                                <button
                                  key="cancel"
                                  type="button"
                                  className="btn btn-secondary btn-sm mr-2"
                                  onClick={() => {
                                    setVersantSkipMode(false);
                                    setVersantSkipReason("");
                                  }}
                                >
                                  Cancel
                                </button>,
                                <button
                                  key="submit"
                                  type="button"
                                  className="btn btn-primary btn-sm"
                                  disabled={!versantSkipReason || disable}
                                  onClick={async () => {
                                    await handleSkipVersant();
                                  }}
                                >
                                  Submit
                                </button>
                              ]}
                            >
                              <div className="form-group mt-2" style={{ marginBottom: "20px" }}>
                                <label className="font-weight-bold mb-2">Select Reason</label>
                                <select
                                  className="form-control form-control-sm"
                                  style={{ padding: "4px 8px", height: "auto" }}
                                  value={versantSkipReason}
                                  onChange={(e) => setVersantSkipReason(e.target.value)}
                                >
                                  <option value="">-- Select Reason --</option>
                                  <option value="Regional Candidate">Regional Candidate</option>
                                  <option value="Movement from NAPS/NATS">Movement from NAPS/NATS</option>
                                </select>
                              </div>
                            </Modal>
                          </div>
                        )}
                        {interviews?.length === 0 && canArrangeInterview && candidate?.trf?.candidateType === "Non-Agent" && (
                          <>
                            <button
                              disabled={disable}

                              className={`btn btn-primary btn-sm mr-2`}
                              onClick={onClickArrangeWithMe}
                            >
                              Quick Arrange
                            </button>
                          </>
                        )}
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={toggleExpanded}
                        >
                          <i
                            className={
                              expanded
                                ? "fa fa-minus-circle"
                                : "fa fa-plus-circle"
                            }
                          ></i>
                        </button>
                      </div>
                    </div>
                    <div
                      className={
                        expanded
                          ? "card-body-animated"
                          : "card-body-animated card-body-hidden"
                      }
                    >
                      <div className="card-body ">
                        <Formik
                          key={`${tinType || "no-versant"}-${totalArrangedInterView}-${defaultInterviewType}`}
                          initialValues={initialValues}
                          validationSchema={validationSchema}
                          onSubmit={onSubmitInterview}
                        >
                          {(formikProps) => (
                            <Form>

                              <div>
                                <label htmlFor="type">Type</label>
                                <Field
                                  as="select"
                                  name="type"
                                  className="form-control"
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    formikProps.setFieldValue("type", value);

                                    if (value === "clientRound") {
                                      formikProps.setFieldValue(
                                        "interviewer",
                                        "",
                                      );
                                    } else {
                                      formikProps.setFieldValue(
                                        "clientInterviewer",
                                        "",
                                      );
                                    }
                                    formikProps.setFieldValue(
                                      "sendInterviewLink",
                                      false,
                                    );
                                  }}
                                >
                                  {totalArrangedInterView === 0 && (
                                    <option value="L1">L1</option>
                                  )}
                                  {totalArrangedInterView === 1 && (
                                    <option value="L2">L2</option>
                                  )}
                                  {totalArrangedInterView === 2 && (
                                    <>
                                      {tinType ? (
                                        <option value="versant">Versant</option>
                                      ) : (
                                        <>
                                          <option value="">Select type</option>
                                          <option value="final">Final</option>
                                          <option value="clientRound">
                                            Client
                                          </option>
                                        </>
                                      )}
                                    </>
                                  )}
                                  {totalArrangedInterView == 3 && (
                                    <>
                                      <option value="">Select type</option>
                                      <option value="final">Final</option>
                                      <option value="clientRound">Client</option>
                                    </>
                                  )}
                                </Field>

                                <ErrorMessage
                                  render={(msg) => (
                                    <div className="alert alert-danger my-1">
                                      {msg}
                                    </div>
                                  )}
                                  name="type"
                                />
                              </div>

                              {formikProps.values.type === "versant" &&
                                tinType && (
                                  <div className="mt-2">
                                    <TinManageArrange
                                      tinOptions={tinOptions}
                                      tinData={tinData}
                                    />
                                  </div>
                                )}

                              {formikProps.values.type === "clientRound" &&
                                totalArrangedInterView > 1 ? (
                                <div className="mt-2">
                                  <label htmlFor="interviewer">
                                    Client Name
                                  </label>
                                  <Field
                                    className="form-control"
                                    name="clientInterviewer"
                                  >
                                    {({ field, form, meta }) => {
                                      const options = clientData?.map(
                                        (user) => {
                                          return {
                                            label: `${user.name}`,
                                            value: user._id,
                                          };
                                        },
                                      );
                                      return (
                                        <>
                                          <Select
                                            name={field.name}
                                            value={
                                              options
                                                ? options.find(
                                                  (option) =>
                                                    option.value ===
                                                    field.value,
                                                )
                                                : ""
                                            }
                                            onChange={(option) => {
                                              form.setFieldValue(
                                                field.name,
                                                option.value,
                                              );
                                            }}
                                            onBlur={field.onBlur}
                                            options={options}
                                          />
                                          {meta.touched && meta.error ? (
                                            <div className="alert alert-danger my-1">
                                              {meta.error}
                                            </div>
                                          ) : null}
                                        </>
                                      );
                                    }}
                                  </Field>
                                </div>
                              ) : formikProps.values.type !== "versant" ? (
                                <div>
                                  <div className="mt-2">
                                    <label htmlFor="interviewer">
                                      Interviewer
                                    </label>
                                    <Field
                                      className="form-control"
                                      name="interviewer"
                                    >
                                      {({ field, form, meta }) => {
                                        const options = users.map((user) => {
                                          return {
                                            label: `${user.name} (${user.role})`,
                                            value: user._id,
                                          };
                                        });
                                        return (
                                          <>
                                            <Select
                                              name={field.name}
                                              value={
                                                options
                                                  ? options.find(
                                                    (option) =>
                                                      option.value ===
                                                      field.value,
                                                  )
                                                  : ""
                                              }
                                              onChange={(option) => {
                                                form.setFieldValue(
                                                  field.name,
                                                  option.value,
                                                );
                                              }}
                                              onBlur={field.onBlur}
                                              options={options}
                                            />
                                            {meta.touched && meta.error ? (
                                              <div className="alert alert-danger my-1">
                                                {meta.error}
                                              </div>
                                            ) : null}
                                          </>
                                        );
                                      }}
                                    </Field>
                                  </div>
                                </div>
                              ) : null}

                              {isAgent && (
                                <div className="mt-2">
                                  <label className="d-flex align-items-center mb-0">
                                    <Field
                                      type="checkbox"
                                      name="sendInterviewLink"
                                      disabled={
                                        sendingInterviewLink ||
                                        !formikProps.values.type
                                      }
                                      onChange={(e) => {
                                        const checked = e.target.checked;
                                        if (checked && !isProfilePhotoUploaded()) {
                                          swal({
                                            icon: "warning",
                                            title:
                                              "Please upload candidate profile photo before sending interview link.",
                                          });
                                          formikProps.setFieldValue("sendInterviewLink", false);
                                          return;
                                        }
                                        formikProps.setFieldValue("sendInterviewLink", checked);
                                      }}
                                    />
                                    <span className="ml-2 font-weight-bold">
                                      Send Video Interview Link
                                      {isMandatoryInterviewLink(
                                        formikProps.values.type,
                                      ) && (
                                          <span className="text-danger"> *</span>
                                        )}
                                    </span>
                                  </label>
                                  <div className="text-muted small ml-4 mt-1" style={{ fontSize: "11px" }}>
                                    Phygital link will be sent to candidate on Whatsapp
                                  </div>
                                </div>
                              )}

                              <div className="mt-2">
                                <label htmlFor="description">Message</label>
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="description"
                                />
                                <ErrorMessage
                                  render={(msg) => (
                                    <div className="alert alert-danger my-1">
                                      {msg}
                                    </div>
                                  )}
                                  name="description"
                                />
                              </div>

                              {formikProps.values.type === "video" ? (
                                <div className="form-group">
                                  <label htmlFor="link">Link</label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    name="link"
                                  />
                                  <ErrorMessage
                                    render={(msg) => (
                                      <div className="alert alert-danger my-1">
                                        {msg}
                                      </div>
                                    )}
                                    name="link"
                                  />
                                </div>
                              ) : null}

                              <div className="mt-2">
                                <label htmlFor="start">Start Time </label>
                                <div>
                                  <DatePickerField
                                    type="text"
                                    className="form-control"
                                    name="start"
                                    showTimeSelect
                                    dateFormat="Pp"
                                    popperPlacement="top-end"
                                    minDate={new Date()}
                                  />
                                </div>
                                <ErrorMessage
                                  render={(msg) => (
                                    <div className="alert alert-danger my-1">
                                      {msg}
                                    </div>
                                  )}
                                  name="start"
                                />
                              </div>

                              <div className="mt-2">
                                <label htmlFor="end">End Time</label>
                                <div>
                                  <DatePickerField
                                    type="text"
                                    className="form-control"
                                    name="end"
                                    showTimeSelect
                                    dateFormat="Pp"
                                    popperPlacement="top-end"
                                    minDate={new Date()}
                                  />
                                </div>
                                <ErrorMessage
                                  render={(msg) => (
                                    <div className="alert alert-danger my-1">
                                      {msg}
                                    </div>
                                  )}
                                  name="end"
                                />
                              </div>

                              <div className="mt-3 flex flex-col">
                                {canArrangeInterview && (
                                  <button
                                    className={`btn btn-primary`}
                                    type={candidate?.responses?.length === 0 && totalArrangedInterView > 0 ? "button" : "submit"}
                                    disabled={candidate?.responses?.length === 0 && totalArrangedInterView > 0 ? false : disable}
                                    onClick={
                                      candidate?.responses?.length === 0 && totalArrangedInterView > 0
                                        ? () => {
                                          swal({
                                            icon: "warning",
                                            title: "Please fill the candidate form",
                                          });
                                        }
                                        : undefined
                                    }
                                  >
                                    {sendingInterviewLink
                                      ? "Sending Link..."
                                      : "Arrange"}
                                  </button>
                                )}
                                <ButtonHint>
                                  This will move candidate to the next board in
                                  the Screening Board.
                                </ButtonHint>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      </div>
                    </div>
                  </div>
                )}
            </>
          )}
        </>
      </div>
    </div>
  );
}

export default CandidateSingleInterview;
